module.exports = __webpack_public_path__ + "media/images/facebook-b2acf0a03be8f248c3e9979d7997c82a.svg";